import React from 'react';
import { selectResources, selectPostFormData } from '../store/selectors';
import { connect } from 'react-redux';
import { InsuranceProduct } from './insurance-product-box';

const InsuranceGuide = ({ resources, postForm }) => {
    const { fsguide } = resources;
    const isPostDataEmpty = postForm === '';

    return (
        <div className="container">
            {!isPostDataEmpty ? (
                <>
                    <div className="u-Space-down--lg">
                        <h2>{fsguide.title}</h2>
                    </div>
                    <InsuranceProduct />
                </>
            ) : null}
        </div>
    );
};

const mapStates = (state) => ({
    resources: selectResources(state),
    postForm: selectPostFormData(state)
});

export default connect(mapStates, null)(InsuranceGuide);
